{
  "id": "001-003",
  "title": "Trading places",
  "version": 0,
  "layout": {
    "tiles": {
      "0": {
        "0": {
          "id": "dbf74c17",
          "type": "tile"
        },
        "1": {
          "id": "a4f181e1",
          "type": "tile"
        },
        "-1": {
          "id": "fb798c61",
          "type": "tile"
        }
      },
      "1": {
        "0": {
          "id": "c33f42c2",
          "type": "tile"
        },
        "-1": {
          "id": "1b291584",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 1,
                  "toggled": true
                }
              ],
              "id": "ef126477"
            }
          ],
          "modifiers": [
            {
              "type": "swap",
              "id": "362fdc23"
            }
          ]
        }
      },
      "-1": {
        "0": {
          "id": "1340ed3e",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 4,
                  "toggled": true
                }
              ],
              "id": "842d4005"
            }
          ]
        },
        "-1": {
          "id": "3622ae8a",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "id": "dddfa2dd",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 4
                }
              ]
            }
          ],
          "modifiers": [
            {
              "type": "rotate",
              "id": "3b976366"
            }
          ]
        }
      }
    }
  },
  "requirements": [
    {
      "type": "connections",
      "amount": 1
    }
  ]
}
